import { AuthTokens } from '../types';

/**
 * Single source of truth for where JWTs live in the browser.
 *
 * The axios interceptor in api.ts runs outside React and reads these flat
 * keys, while the zustand auth store persists its own snapshot under
 * `pathfindr-auth`. Both go through this module so they cannot drift.
 */

const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

export const getAccessToken = (): string | null =>
  localStorage.getItem(ACCESS_TOKEN_KEY);

export const getRefreshToken = (): string | null =>
  localStorage.getItem(REFRESH_TOKEN_KEY);

export const setTokens = (tokens: AuthTokens): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, tokens.access);
  localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refresh);
};

export const setAccessToken = (access: string): void => {
  localStorage.setItem(ACCESS_TOKEN_KEY, access);
};

export const setRefreshToken = (refresh: string): void => {
  localStorage.setItem(REFRESH_TOKEN_KEY, refresh);
};

export const clearTokens = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};
